import { preventTimeZoneDate } from "./preventTimeZone";

const findNameKey = (item) => {
    let possibleOptions = ["Filename", "name", "filename", "Name"];
    let length = possibleOptions.length;
    let name;
    for (let i = 0; i < length; i++) {
        let option = possibleOptions[i];
        if (item[option] !== undefined) {
            name = option;
            break;
        }
    }

    return name;
};

const findURLKey = (item) => {
    let possibleOptions = ["URL", "url"];
    let length = possibleOptions.length;
    let name = false;
    for (let i = 0; i < length; i++) {
        let option = possibleOptions[i];
        if (item[option] !== undefined) {
            name = option;
            break;
        }
    }

    return name;
};

export function ensureFileId(object) {
    if (!object.attachments) return object;
    if (!object.attachments.length === 0) return object;

    const newAttachments = object.attachments.map((item) => {
        return {
            ...item,
            FileId: item?.FileId ? item.FileId : item.id,
            inEdit: true,
            id: item?.FileId ? item.FileId : item.id,
            Uploaded: item.Uploaded
                ? preventTimeZoneDate(item.Uploaded)
                : item.date
                ? preventTimeZoneDate(item.date)
                : new Date().toLocaleDateString(),
            EffectiveDate: item.EffectiveDate ? preventTimeZoneDate(item.EffectiveDate) : null,
            showName: item?.showName ? item.showName : item[findNameKey(item)],
            urlName: item?.urlName ? item.urlName : item[findURLKey(item)],
            Type: item?.Type ? item.Type : item?.type ? item.type : "",
            Note: item?.Note ? item.Note : item?.note ? item.note : "",
        };
    });

    object.attachments = newAttachments;

    return object;
}

export function cleanAttachment(attachment) {
    if (!attachment) {
        return;
    }

    return {
        ...attachment,
        FileId: attachment.FileId,
        inEdit: true,
        id: attachment.FileId,
        Uploaded: attachment.Uploaded
            ? preventTimeZoneDate(attachment.Uploaded)
            : attachment.date
            ? preventTimeZoneDate(attachment.date)
            : new Date().toLocaleDateString(),
        showName: attachment.showName ? attachment.showName : attachment[findNameKey(attachment)],
        urlName: attachment.urlName ? attachment.urlName : attachment[findURLKey(attachment)],
        Type: attachment.Type ? attachment.Type : attachment.type ? attachment.type : "",
        Note: attachment.Note ? attachment.Note : attachment.note ? attachment.note : "",
    };
}
